import React from 'react';
import { connect } from "react-redux";
import { logoutUser, } from "../services/common/action";
import { NavLink, withRouter } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import Loader from "react-loader-spinner";

class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            userType: "",
            profileName: "",

        }
    }
    homeRoute = (e) => {
        e.preventDefault();
         switch (this.state.userType) {

            case "patient":
                this.props.history.push("/PatientHome");
                break;
            case "facility":
                this.props.history.push("/FacilityHome");
                break;
            case "admin":
                this.props.history.push("/AdminHome");
                break;
            case "employee":
                this.props.history.push("/EmployeHome");
                break;
            case "other":
                this.props.history.push("/PatientHome");
            break;
            default:
            break;
        }
    }

    logout = (e) => {
        e.preventDefault();
        this.props.history.push("/login");
        this.props.logoutUser();
    };

    componentDidMount() {
        if (this.props.profileDetails) {
            let userType = this.props.profileDetails.commonUser.userType;
            let profileName = this.props.profileDetails.commonUser.firstName;

            this.setState({
                userType,
                profileName,

            })

        }
    }

    componentWillReceiveProps = nextProps => {
        if (this.props.profileDetails != nextProps.profileDetails) {
            if (nextProps.profileDetails) {
                let name = nextProps.profileDetails.commonUser.firstName
                this.setState({
                    profileName: name
                })
            }
        }
    }

    ProfileRoute = (e) => {
        e.preventDefault();
        this.props.history.push("/ViewProfile")
    }


    SettingRoute = (e) => {
        e.preventDefault();
        this.props.history.push("/Settings")
    }

    render() {
        const { status, routes, isLoading } = this.props
        // toast.success("Success Notification !", {
        //     position: toast.POSITION.TOP_CENTER
        //   });
        return (

            <div>

                {isLoading && (
                    <div className="pop-mod">
                        <div className="loder-back">
                            <Loader
                                 type="Ball-Triangle"
                                color="#00BFFF"
                                height="100"
                                width="100"
                            />
                        </div>
                    </div>
                )}
             
               
                    <div>

                        <ToastContainer hideProgressBar autoClose={3000} />


                        <div className="header-sec">
                            <div className="header">
                                <div className="main-logo">
                                    <h1>ePaper Road</h1>

                                </div>
                        {status === "afterLogin" &&
                                <div className="use-logo">
                                    <div className="dropdown">
                                        <div data-toggle="dropdown">
                                            <img src="images/login.jpg" /> <label>{this.state.profileName ? "Hello  " + this.state.profileName : "Hello Friend"}</label>
                                            <span className="caret"></span>
                                        </div>
                                        <ul className="dropdown-menu">
                                            <li>
                                                <a href="javascript:void(0)" onClick={this.homeRoute}><i className="fa fa-home" aria-hidden="true"></i><span className="menu-icon">My Home</span></a>
                                            </li>
                                            <li><a href="javascript:void(0)" onClick={this.ProfileRoute}><i className="fa fa-user" aria-hidden="true"></i><span className="menu-icon">My Profile</span></a></li>
                                            <li><a href="javascript:void(0)" onClick={this.SettingRoute}><i className="fa fa-cog" aria-hidden="true"></i><span className="menu-icon">Settings</span></a></li>

                                            <li>
                                                <NavLink
                                                    to=""
                                                    onClick={this.logout}
                                                    className="dropdown-item">
                                                    <i className="fa fa-sign-out" aria-hidden="true"></i>
                                                   <span className="menu-icon">Logout</span>
                                                </NavLink>
                                            </li>

                                        </ul>
                                    </div>

                                </div>
                            }
                            </div>
                            {routes &&
                            <div className="register-nextpagelink">
                                <div className="container">
                                    <div className="row">
                                        <div className="nextpage-link">
                                            <ul className="breadcrumb">
                                            {routes.map((item,id)=>{
                                                return(
                                                <li key={id} ><NavLink className={item.active} to={item.route}>{item.name}</NavLink></li>
                                                )}
                                                )}
                                             </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            }


                        </div>
                    </div>


                
            </div>



        )
    }
}
const mapStateToProps = state => ({
    profileDetails: state.commonReducer.profileDetails,
    loginDetails: state.commonReducer.loginDetails,
    loginStatus: state.commonReducer.loginStatus,
    isLoading: state.commonReducer.isLoading
});
const mapDispatchToProps = dispatch => ({
    logoutUser: () => dispatch(logoutUser()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(Header));

